import React from 'react';

const CircleUser = () => {
  return (
    <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#xhyzkr64va)">
        <path
          d="M100 0C44.766 0 0 44.766 0 100s44.766 100 100 100 100-44.766 100-100S155.234 0 100 0zm0 187.5c-18.453 0-35.563-5.773-49.688-15.562C51.914 152.695 67.892 137.5 87.5 137.5h25c19.629 0 35.602 15.211 37.191 34.438C135.547 181.719 118.438 187.5 100 187.5zm60.82-24.727c-5.507-21.64-25-37.773-48.32-37.773h-25c-23.332 0-42.813 16.133-48.32 37.781C22.762 146.523 12.5 124.609 12.5 100c0-48.242 39.258-87.5 87.5-87.5s87.5 39.258 87.5 87.5c0 24.609-10.273 46.523-26.68 62.773zM100 50c-17.266 0-31.25 13.984-31.25 31.25S82.734 112.5 100 112.5s31.25-13.992 31.25-31.25C131.25 63.984 117.266 50 100 50zm0 50c-10.352 0-18.75-8.398-18.75-18.75S89.648 62.5 100 62.5s18.75 8.41 18.75 18.75S110.352 100 100 100z"
          fill="#A6A6A6"
        />
      </g>
      <defs>
        <clipPath id="xhyzkr64va">
          <path fill="#fff" d="M0 0h200v200H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CircleUser;
